import React, { useState, useRef } from "react";
import '../css/AboutUs.css'
import Navbar from "./Navbar";

const AboutUs = () => {
const faqs = [
  {
    question: "How long does shipping take?",
    answer: "2-5 working days from the moment your items have arrived at our office and payment has been made.",
  },
  {
    question: "What address should I use when ordering from Malaysia Online Shops?",
    answer: "Delivery address: 02 - 33, Jalan Austin Perdana 3/8, Taman Mount Austin, 81100, Tebrau.",
  },
  {
    question: "How will I know when my item has arrived at the locker?",
    answer: "You will receive a WhatsApp and in-app notification with a One-Time password and locker number once your item is delivered and full payment has been made to us. (If your items do not fit in the locker, balance payment for a bigger locker will be required)",
  },
  {
    question: "What sizes are available for the lockers?",
    answer: (
      <span>
        We have four locker sizes available --- Extra Small, Small, Medium and Large. Please refer to the Locker Sizing:{" "}
        <a 
          href="/locker-sizes" 
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ color: "#007bff", textDecoration: "underline" }}
        >
          Click here to view locker sizes
        </a>.
      </span>
    ),
  },
  {
    question: "Can you deliver the item to my home in Singapore?",
    answer: "Yes! You may request for Cross-Border Delivery before making payment for your order. Do note that you will have to declare the item that you are purchasing and its value.",
  },
  {
    question: "Is there a delivery fee for sending items to Singapore?",
    answer: "Yes, We charge based on the order weight or volumetric weight. Our rates are as such - 1st KG 30rm, subsequent KG 10rm e.g. An order weighing 2.4KG will be charged at 45rm.",
  },
  {
    question: "Can I store my item in the locker for a few days before picking it up?",
    answer: "Yes, we offer up to 7 days of free locker storage. After that, a small daily fee applies to hold your item securely.",
  },
  {
    question: "Is it safe to send expensive items to the locker?",
    answer: "Absolutely. Our lockers are monitored 24/7 and located in secure, accessible areas. You’ll receive a one-time access code for maximum safety.",
  },
  {
    question: "How do I subscribe to locker services?",
    answer: "Simply download our app and place an order for a locker, and you’ll get immediate access to your locker address. Which you can use to send your items to.",
  },
  {
    question: "What are the prohibited items to place in the locker?",
    answer: (
      <span>
        You are not allowed to store illegal, flammable, or restricted items in the locker. 
        Please refer to the official list by ICA Singapore:{" "}
        <a 
          href="https://www.ica.gov.sg/enter-transit-depart/entering-singapore/what-you-can-bring" 
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ color: "#007bff", textDecoration: "underline" }}
        >
          Click here to view prohibited items
        </a>.
      </span>
    ),
  }
];

  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]); // refs to each answer div

  const toggleFAQ = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <div className="aboutuspage">
      <div className="content">
   <Navbar/>
        <div
          style={{
            maxWidth: 800,
            margin: "40px auto",
            marginTop: '350px'
,            padding: "0 20px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <h1 style={{ textAlign: "center", marginBottom: 30, textDecoration: 'underline' }}>Frequently Asked Questions</h1>

          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            // Get the height of the content dynamically
            const contentHeight = contentRefs.current[index]?.scrollHeight || 0;

            return (
              <div
                key={index}
                onClick={() => toggleFAQ(index)}
                style={{
                  borderBottom: "1px solid #ccc",
                  padding: "15px 0",
                  cursor: "pointer",
                  userSelect: "none",
                  width: '100%'
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 18,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign:'left'
                  }}
                >
                  {faq.question}
                  <span
                    style={{
                      fontSize: 24,
                      transition: "transform 0.3s ease",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                      lineHeight: 1,
                    }}
                  >
                    +
                  </span>
                </div>

                <div
                  ref={(el) => (contentRefs.current[index] = el)}
                  style={{
                    height: isOpen ? contentHeight : 0, // Animate to scrollHeight or 0
                    opacity: isOpen ? 1 : 0,
                    paddingTop: isOpen ? 8 : 0,
                    paddingBottom: isOpen ? 8 : 0,
                    overflow: "hidden",
                    transition: "height 0.35s ease, opacity 0.3s ease, padding 0.3s ease",
                    fontSize: 16,
                    color: "#ccccccb7",
                    textAlign: 'left'
                  }}
                >
                  {faq.answer}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;